module.exports = __webpack_public_path__ + "static/media/002.2e0a4373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/002.jpg
// module id = 349
// module chunks = 0